import type {
  ShopShiftReportByDayRow,
  ShopShiftReportByStaffRow,
} from "@/modules/merchant/presentation/api/client";

export type ShiftReportTotals = {
  assignments: number;
  clockIn: number;
  fullyClocked: number;
  staffCount: number;
  pendingSwaps: number;
};

export function computeShiftReportTotals(
  byDay: ShopShiftReportByDayRow[],
  byStaff: ShopShiftReportByStaffRow[],
  pendingSwaps: number,
): ShiftReportTotals {
  let assignments = 0;
  let clockIn = 0;
  let fullyClocked = 0;

  for (const row of byDay) {
    assignments += row.assignmentCount;
    clockIn += row.withClockInCount;
    fullyClocked += row.fullyClockedCount;
  }

  return {
    assignments,
    clockIn,
    fullyClocked,
    staffCount: byStaff.length,
    pendingSwaps,
  };
}

export function completionRate(fullyClocked: number, assignments: number): number {
  if (assignments <= 0) return 0;
  return Math.round((fullyClocked / assignments) * 100);
}
